import { render, staticRenderFns } from "./huiyi.vue?vue&type=template&id=4476bb08&"
import script from "./huiyi.vue?vue&type=script&lang=js&"
export * from "./huiyi.vue?vue&type=script&lang=js&"
import style0 from "./huiyi.vue?vue&type=style&index=0&id=4476bb08&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports